'use strict'

import WheelList from '@/pages/Wheel/WheelList.vue'
import Wheel from '@/pages/Wheel/Wheel.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/wheel',
    name: 'Wheels',
    component: WheelList,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: '/:site/wheel/:id',
    name: 'Wheel',
    component: Wheel,
    beforeEnter: ifAuthenticated,
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/wheel.js